import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { AiFillInstagram } from "react-icons/ai";
import { MdMail } from "react-icons/md";


const Wrapper = styled.div`
  margin-top: 50px;
  
`;

const ContactLink = styled.a`

  display: flex;
  align-items: center;
  border-radius: ${props => props.theme.defaultBorderRadius};
  background-color:  ${props => props.theme.colors.primary}; ;
  width: 250px;
  justify-content: space-between;
  padding: 0 25px;
  color: white;
  
  margin-bottom: 15px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }
  
  &:hover {
    cursor: pointer;

    svg {
      // color: ${props => props.theme.colors.secondary} !important;
    }
    
  }
  
  svg {
    margin: 5px;
  }
`

const Contact: FunctionComponent = () => {



    return (

        <Wrapper>
            <h3>Bądźmy w kontakcie</h3>
            <ContactLink href="https://instagram.com/kinga.rybarczyk">
               <span>Zajrzyj na instagrama</span> <AiFillInstagram size={30} color={'white'} />
            </ContactLink>

            <ContactLink href="mailto: rybarczykinga@gmail.com">
                <span>Napisz do mnie</span> <MdMail size={32} color={'white'} />
            </ContactLink>
        </Wrapper>
    )
}

export default Contact;